import { render } from "./Header.vue?vue&type=template&id=462f6f07&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=462f6f07&scoped=true&lang=css"

import exportComponent from "/home/sysadmin/shared-platform-web-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462f6f07"]])

export default __exports__